<template>
  <div>
    <!-- Top -->
    <section class="header-b" :style="headerCover">
      <div class="row">
        <div class="col-lg-2 col-sm-12 col-md-4">
          <!-- Business Logo -->
          <div class="d-flex flex-img">
            <img :src="logo" />
          </div>
          <!-- Business Logo -->
        </div>

        <div class="col-lg-6 col-sm-12 col-md-8">
          <div class="d-flex flex-detail">
            <ul>
              <li v-if="business.title" class="list-item">
                <i
                  class="icon-wishlist"
                  :style="{ color: +business.is_wish ? '#8c8cf5' : 'white' }"
                  @click.prevent="changeWish"
                ></i>
                <h5 v-text="business.title"></h5>
              </li>
              <!-- <li v-if="address" class="list-item">
                <i class="icon-search-location"></i>
                <h6 class="list-item-h6" v-text="address"></h6>
              </li>-->
              <li v-if="business.phone" class="list-item">
                <i class="icon-phone"></i>
                <h6 v-text="business.phone"></h6>
              </li>
              <li v-if="business.fax != '0'" class="list-item">
                <i class="icon-fax"></i>
                <h6 v-text="business.fax"></h6>
              </li>
              <li v-if="business.email" class="list-item">
                <i class="icon-email-line"></i>
                <h6 v-text="business.email"></h6>
              </li>

              <!-- Network Link -->
              <li class="list-item">
                <a v-for="key in networkLink" :key="key[1]" :href="key[0]">
                  <i :class="key[2]"></i>
                </a>
              </li>
              <!-- Network Link -->
            </ul>
          </div>
        </div>

        <div class="col-lg-4 col-sm-12 col-md-12">
          <div class="d-flex point-flex">
            <!-- Rate Techchi -->
            <div class="point d-flex">
              <b-form-rating
                id="rating-inline"
                readonly
                :value="business.rate"
                color="#ffc61a"
              ></b-form-rating>

              <div v-if="business.rate" class="Vote">
                <span>{{ business.rate }} از مجموع</span>
                <span>{{ business.rate_count }} رای</span>
              </div>

              <div v-else class="Vote">
                <span>امتیازی ثبت نشده</span>
              </div>

              <b-popover
                target="popover-target-1"
                triggers="click"
                placement="top"
              >
                <b-form-rating
                  id="rate"
                  v-model="rate"
                  color="#ffc61a"
                  size="lg"
                ></b-form-rating>
              </b-popover>

              <!-- <div class="Score d-flex" id="popover-target-1">
                <span>
                  <a href>امتیاز دهید !</a>
                </span>
              </div>-->

              <button class="Score d-flex" id="popover-target-1">
                <span>امتیاز دهید !</span>
              </button>
            </div>
            <!-- Rate Techchi -->

            <!-- Tech Chi Rate -->
            <!-- <TechChiRate :rate="business.rate" /> -->
            <!-- Tech Chi Rate -->

            <!-- Business Info -->
            <div class="score-option row">
              <div class="col-lg-3 col-sm-3 score-option-repan">
                <span v-text="business.wish_count || 0"></span>
                <p class="width-3">علاقه مندی</p>
              </div>
              <div class="col-lg-3 col-sm-3 score-option-repan">
                <span v-text="business.view_count || 0"></span>
                <p class="width-4">بازدید کننده</p>
              </div>
              <div class="col-lg-2 col-sm-2 score-option-repan">
                <span v-text="business.comment_count || 0"></span>
                <p>نظر</p>
              </div>
              <div class="col-lg-2 col-sm-2 score-option-repan">
                <span
                  class="khdmat"
                  v-text="business.service_count || 0"
                ></span>
                <p>سرویس</p>
              </div>
              <div class="col-lg-2 col-sm-2 score-option-repan">
                <span v-text="business.product_count || 0"></span>
                <p>محصول</p>
              </div>
            </div>
            <!-- Business Info -->
          </div>
        </div>
      </div>
    </section>
    <!-- Top -->

    <!-- Tabs -->
    <section>
      <div class="container-f col-sm-12">
        <!-- SelectTab -->
        <Tabs :tabs="tabs" />
        <!-- SelectTab -->

        <!-- Components -->
        <router-view></router-view>
        <!-- Components -->
      </div>
    </section>
    <!-- Tabs -->
  </div>
</template>

<script>
import axios from "@/axios.js";

import Tabs from "./Tabs";

import { url } from "@/mixins.js";

export default {
  name: "business",

  props: ["username"],

  mixins: [url],

  data() {
    return {
      business: {},
      rate: 0,
      color: "white",
      tabs: {
        product: {
          title: "بسته های حمایتی",
          icon: "icon-goods",
          value: 0,
        },
        about: {
          title: "درباره ما",
          icon: "icon-about",
          value: 1,
        },
        // point: {
        //   title: "امتیاز",
        //   icon: "icon-about",
        //   value: 0,
        // },
        comment: {
          title: "نظرات کاربران",
          icon: "icon-user-comment",
          value: 1,
        },
        
        // group: {
        //   value: 0,
        //   icon: "icon-group",
        //   title: "گروه های کاری",
        // },
        gallery: {
          value: 0,
          icon: "icon-gallery",
          title: "گالری",
        },
        service: {
          value: 0,
          icon: "icon-service",
          title: "خدمات",
        },
        // information: {
        //   value: 0,
        //   icon: "icon-info",
        //   title: "اطلاعات",
        // },
        posts: {
          value: 0,
          icon: "icon-post",
          title: "پست ها",
        },
      },
    };
  },

  components: {
    Tabs,
  },

  async beforeRouteEnter(t, f, n) {
    if (t.params.username == "search") {
      n({ name: "Search" });
    } else {
      await axios
        .get("business/read_one_init.php", {
          params: {
            username: t.params.username,
          },
        })
        .then((d) => {
          switch (d.data.msg) {
            case "404":
              n({ name: "notFound" });
              break;

            case "new":
              break;

            case "published":
              break;

            case "rejected":
              break;

            case "account_time_finished":
              break;

            case "unable_to_get":
              break;

            default:
              n((vm) => {
                vm.setData(d);
              });

            // axios.get("static/tabs.json").then((data) => {
            //   n((vm) => {
            //     vm.setTabs(data.data);
            //     vm.setData(d);
            //   });
            // });
          }
        })
        .catch((err) => console.error("Error Response read_one_init ::", err));
    }
  },

  computed: {
    headerCover() {
      let src = "assets/images/business/";
      src = this.url + src + this.business.cover_img;

      return {
        background: `url('${src}') center no-repeat`,
      };
    },

    logo() {
      let src = "assets/images/business/";
      src = this.url + src + this.business.img_url;

      return src;
    },

    networkLink() {
      return this.business.network_link_values;
    },

    address() {
      if (!this.business.address) return;

      let add = "";

      let province_title = this.business.address[0].province_title || "";
      let city_title = this.business.address[0].city_title || "";
      let area_number = this.business.address[0].area_number || "";
      let district_title = this.business.address[0].district_title || "";
      let postal_address = this.business.address[0].postal_address || "";

      add = add.concat(
        "استان ",
        province_title,
        "، شهر ",
        city_title,
        "، منطقه ",
        area_number,
        "، ",
        district_title,
        " ",
        postal_address
      );

      return add;
    },
  },

  methods: {
    view() {
      axios.post("business/create_view.php", { business_id: this.business.id });
    },

    addRate() {
      axios
        .post("business/create_rate.php", {
          business_id: this.business.id,
          rate_value: this.rate,
        })
        .then((r) => {
          // if (r.data.msg == "success") {
          //   this.$snotify.success("امتیاز شما ثبت شد.");
          // } else {
          //   this.$snotify.error("خطایی رخ داده دوباره تلاش کنید.");
          // }
          switch (r.data.msg) {
              case "success":
                this.$snotify.success("امتیاز شما ثبت شد.");
                break;

              case "unable_to_set":
                this.$snotify.warning("خطا در داده ارسالی");
                break;

              case "login_err":
                this.$snotify.warning("ابتدا وارد حساب کاربری خود شوید.");
                this.$root.$emit("bv::show::modal", "signin-real-person");
                break;

              default:
                this.$snotify.error("خطا در ارتباط با سرور");
            }
        })
        .catch((r) => console.err("Response Error create Rate ::", r));
    },

    changeWish() {
      if (+this.business.is_wish) {
        axios
          .post("business/delete_wishlist.php", {
            business_id: this.business.id,
          })
          .then((r) => {
            switch (r.data.msg) {
              case "success":
              case "already_wished":
                this.business.is_wish = "0";
                this.$snotify.success("از علاقه مندی حذف شد.");
                break;

              case "unable_to_set":
                this.$snotify.warning("خطا در داده ارسالی");
                break;

              case "login_err":
                this.$snotify.warning("ابتدا وارد حساب کاربری خود شوید.");
                this.$root.$emit("bv::show::modal", "signin-real-person");
                break;

              default:
                this.$snotify.error("خطا در ارتباط با سرور");
            }
          })
          .catch((er) =>
            console.error("Response Error delete_wishlist ::", er)
          );
      } else {
        axios
          .post("business/create_wishlist.php", {
            business_id: this.business.id,
          })
          .then((r) => {
            switch (r.data.msg) {
              case "success":
              case "already_wished":
                this.business.is_wish = "1";
                this.$snotify.success("به علاقه مندی اضافه شد.");
                break;

              case "unable_to_set":
                this.$snotify.warning("خطا در داده ارسالی");
                break;

              case "login_err":
                this.$snotify.warning("ابتدا وارد حساب کاربری خود شوید.");
                 this.$root.$emit("bv::show::modal", "signin-real-person");
                break;

              default:
                this.$snotify.error("خطا در ارتباط با سرور");
            }
          })
          .catch((er) =>
            console.error("Response Error create_wishlist ::", er)
          );
      }
    },

    setData(d) {
      this.business = d.data;

      // if (!this.business.cover_img) {
      //   this.business.cover_img = "business-cover-default.jpg";
      // }
      //
      // if (!this.business.img_url) {
      //   this.business.img_url = "default-business.jpg";
      // }

      localStorage.setItem("business", JSON.stringify(this.business));
      // create View
      this.view();
    },

    setTabs() {
      this.tabs = {
        about: {
          title: "درباره ما",
          icon: "icon-about",
          value: 1,
        },
        point: {
          title: "امتیاز",
          icon: "icon-about",
          value: 0,
        },
        comment: {
          title: "نظرات کاربران",
          icon: "icon-user-comment",
          value: 1,
        },
       product: {
          title: "بسته های حمایتی",
          icon: "icon-goods",
          value: 0,
        },
        // group: {
        //   value: 0,
        //   icon: "icon-group",
        //   title: "گروه های کاری",
        // },
        gallery: {
          value: 0,
          icon: "icon-gallery",
          title: "گالری",
        },
        service: {
          value: 0,
          icon: "icon-service",
          title: "خدمات",
        },
        // information: {
        //   value: 0,
        //   icon: "icon-info",
        //   title: "اطلاعات",
        // },
        posts: {
          value: 0,
          icon: "icon-post",
          title: "پست ها",
        },
      };
    },
  },

  watch: {
    rate() {
      this.addRate();
    },
  },
};
</script>

<style scoped>
#rating-inline {
  padding: 0.175rem 1.15rem;
  font-size: 1.2rem;
  color: #f8f9fa;
  background-color: transparent;
  border: none;
}

#rate {
  cursor: pointer;
  font-size: 1.2rem;
  color: #f8f9fa;
  border: none;
  background-color: transparent;
}

#rate.form-control-lg {
  font-size: 1.25rem;
  line-height: 0.5;
  border: none;
}
.form-control:focus {
  box-shadow: none;
}
.popover-body
  .form-control
  .b-rating-star-full
  .b-rating-icon
  .b-icon
  g
  path:focus {
  outline: none !important;
}
</style>